import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { injectIntl as withIntl } from 'react-intl';

import WithShopDetails from '@shopDetails/HOCs/WithShopDetails';
import { pushPage } from '@shared/actions';
import trackShopDetailsTabs from '@conversion/tracking/actions/trackShopDetailsTabs';
import getShopIsOpen from '@core/reducers/shop/selectors/getShopIsOpen';
import shopCapacityCheckActive from '@core/reducers/shop/selectors/shopCapacityCheckActive';
import getIsFetchingSectionList from '@shopDetails/selectors/getIsFetchingSectionList';
import getIsFetchingMenu from '@core/reducers/menu/selectors/getIsFetchingMenu';
import getShelvesMenuLoadStatus from '@core/reducers/menu/selectors/getShelvesMenuLoadStatus';
import getSectionsList from '@shopDetails/selectors/getSectionsList';
import getGroceriesTabSelected from '@shopDetails/selectors/getGroceriesTabSelected';

import {
  showCatalog,
  showSections,
} from '@shopDetails/actions/groceriesTabChanged';

import {
  getSectionListLoadStatus,
  getVerticalForSelectedShop,
} from '@shopDetails/selectors';
import fetchSectionsList from '@shopDetails/actions/fetchSectionsList';
import getFallbackUrl from '@shopDetails/selectors/getFallbackUrl';
import fetchMenu from '@core/reducers/menu/actions/fetchMenu';
import fetchCapacityCheck from '@shopDetails/actions/fetchCapacityCheck';
import getCanViewCart from '@core/reducers/cart/selectors/getCanViewCart';
import fetchMeasurementUnitsList from '@shopDetails/actions/fetchMeasurementUnitsList';
import trackSectionDetailsLoaded from '@conversion/tracking/actions/trackSectionDetailsLoaded';
import trackSectionListExpanded from '@conversion/tracking/actions/trackSectionListExpanded';

const mapStateToProps = createStructuredSelector({
  isFetchingMenu: getIsFetchingMenu,
  isFetchingSectionList: getIsFetchingSectionList,
  shelvesLoadStatus: getShelvesMenuLoadStatus,
  sectionLoadStatus: getSectionListLoadStatus,
  vertical: getVerticalForSelectedShop,
  fallbackUrl: getFallbackUrl,
  sectionsList: getSectionsList,
  tabSelectedId: getGroceriesTabSelected,
  shopIsOpen: getShopIsOpen,
  capacityCheckActive: shopCapacityCheckActive,
  canViewCart: getCanViewCart,
});

const mapDispatchToProps = {
  pushPage,
  fetchMenu,
  trackShopDetailsTabs,
  showCatalog,
  showSections,
  fetchMeasurementUnitsList,
  fetchSectionsList,
  fetchCapacityCheck,
  trackSectionDetailsLoaded,
  trackSectionListExpanded,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withShopDetails = T => WithShopDetails(T);

export default compose(withShopDetails, withConnect, withIntl);
